import { useRef, useState } from "react";

interface FeedbackBoxProps {
  onSubmit: (feedback: string) => void;
  isLoading: boolean;
  buttonLabel?: string;
}

const CHIPS = [
  "mais técnico",
  "menos jargão",
  "mais bilíngue PT+EN",
  "hooks mais provocativos",
  "mais conciso",
  "mais exemplos concretos",
  "menos formal",
  "mais reflexivo",
];

export const FeedbackBox = ({ onSubmit, isLoading, buttonLabel }: FeedbackBoxProps) => {
  const [text, setText] = useState("");
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  const handleChipClick = (chip: string) => {
    setText((prev) => (prev.trim() ? `${prev}, ${chip}` : chip));
    textareaRef.current?.focus();
  };

  const handleSubmit = () => {
    if (!text.trim() || isLoading) return;
    onSubmit(text.trim());
  };

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {CHIPS.map((chip) => (
          <button
            key={chip}
            type="button"
            onClick={() => handleChipClick(chip)}
            className="rounded-full border border-slate-300 px-3 py-1 text-xs text-slate-700 hover:bg-slate-100 hover:border-slate-400 transition-colors"
          >
            {chip}
          </button>
        ))}
      </div>

      <textarea
        ref={textareaRef}
        value={text}
        onChange={(e) => setText(e.target.value)}
        rows={6}
        placeholder="Descreva os ajustes que quer fazer no seu voice profile…"
        className="w-full rounded-lg border border-slate-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 resize-none"
      />

      <div className="flex justify-end">
        <button
          type="button"
          onClick={handleSubmit}
          disabled={!text.trim() || isLoading}
          className="rounded-lg bg-slate-900 text-white px-4 py-2 text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {buttonLabel ?? (isLoading ? "Refinando…" : "Refinar com IA")}
        </button>
      </div>
    </div>
  );
};
